import { AimsCommonTableHeader, AimsCommonTableHeaderType } from '@aims/common-components';
import { Component, Inject, HostListener, ViewEncapsulation } from '@angular/core';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
    selector: 'permissions',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './permissions.component.html',
    styleUrls: ['./permissions.component.css'],
})

export class PermissionsComponent {
    constructor(public permissions: PermissionsService) {
    }

    showSidebar: boolean = true;
    showButton: boolean = false;
    buttonClick() { 
        this.showSidebar = !this.showSidebar;
    }

    @HostListener('window:resize', ['$event']) onResize(event) {
        let newWidth = event.target.innerWidth;
        if (newWidth < 768) {
            this.showSidebar = false;
            this.showButton = true;
        }
        else {
            this.showSidebar = true;
            this.showButton = false;
        }
    }

  ngOnInit() {
      
    }
    
}
export const UserLookupColumns: AimsCommonTableHeader[] = [
    { key: 'userName', label: 'Username', type: AimsCommonTableHeaderType.STRING },
    { key: 'fullName', label: 'Full Name', type: AimsCommonTableHeaderType.STRING },
    { key: 'jobTitle', label: 'Job Title', type: AimsCommonTableHeaderType.STRING },
    { key: 'assignmentDescription', label: 'Job Assignment', type: AimsCommonTableHeaderType.STRING },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN, filterType: 'boolean', width: 75   }
];
export const ActiveUserLookupColumns: AimsCommonTableHeader[] = [
    { key: 'userName', label: 'Username', type: AimsCommonTableHeaderType.STRING },
    { key: 'fullName', label: 'Full Name', type: AimsCommonTableHeaderType.STRING },
    { key: 'jobTitle', label: 'Job Title', type: AimsCommonTableHeaderType.STRING },
    { key: 'assignmentDescription', label: 'Job Assignment', type: AimsCommonTableHeaderType.STRING }
];
